var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-alert",
    { staticClass: "bloqueo", attrs: { show: "", variant: "danger" } },
    [
      _vm._v(
        "Ha ocurrido un error, intente nuevamente y caso de persistir comuníquese con soporte técnico"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }